import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { BookOpen } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-24 bg-warm-alt relative overflow-hidden" data-id="element-219">
      <div className="max-w-6xl mx-auto px-6" data-id="element-220">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-221">
          <div className="lg:w-1/2" data-id="element-222">
            <FadeIn data-id="element-223">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-warm-accent/10 text-warm-accent font-medium text-sm mb-6" data-id="element-224">
                <BookOpen className="w-4 h-4" data-id="element-225" />
                <span data-id="element-226">Presentando Espalda Libre</span>
              </div>
              <h2 className="text-3xl md:text-5xl font-heading text-warm-dark mb-6 leading-tight" data-id="element-227">
                Cuando el dolor cambia tu vida, necesitas un nuevo camino
              </h2>

              <div className="space-y-6 text-warm-dark/80 text-lg leading-relaxed" data-id="element-228">
                <p data-id="element-229">
                  <strong data-id="element-230">Espalda Libre</strong> no es un libro de medicina ni
                  promete curas milagrosas en 7 días. Es algo mucho más valioso:
                  un mapa trazado por alguien que ya caminó por el bosque oscuro
                  del dolor crónico.
                </p>
                <p data-id="element-231">
                  Es una guía humana, práctica y realista que resume 9 meses de
                  aprendizajes, errores, investigación y herramientas que me
                  ayudaron a salir del dolor y recuperar mi calidad de vida tras
                  el diagnóstico de dos hernias discales.
                </p>
                <p data-id="element-232">
                  Un acompañamiento sincero para que entiendas tu proceso,
                  pierdas el miedo al movimiento y tomes las riendas de tu
                  recuperación.
                </p>
              </div>

              <div className="mt-10" data-id="element-233">
                <Button href="#comprar" data-id="element-234">Descubrir el contenido</Button>
              </div>
            </FadeIn>
          </div>

          <div className="lg:w-1/2 w-full" data-id="element-235">
            <FadeIn direction="left" delay={0.2} data-id="element-236">
              <div className="relative w-full max-w-md mx-auto aspect-[3/4] bg-warm-bg rounded-2xl shadow-xl overflow-hidden border border-warm-accent/20 flex flex-col" data-id="element-237">
                <div className="h-1/2 bg-warm-accent/10 relative overflow-hidden flex items-center justify-center p-8" data-id="element-238">
                  <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-warm-accent to-transparent" data-id="element-239"></div>
                  <h3 className="font-heading text-4xl text-warm-dark text-center relative z-10 leading-tight" data-id="element-240">
                    Espalda
                    <br data-id="element-241" />
                    <span className="italic text-warm-accent" data-id="element-242">Libre</span>
                  </h3>
                </div>
                <div className="h-1/2 p-8 flex flex-col justify-between bg-white" data-id="element-243">
                  <div data-id="element-244">
                    <p className="text-sm text-warm-dark/60 uppercase tracking-widest mb-2" data-id="element-245">
                      Ebook Digital
                    </p>
                    <p className="font-heading text-xl text-warm-dark leading-snug" data-id="element-246">
                      Mi historia real de recuperación sin cirugía
                    </p>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-247">
                    <div className="w-10 h-10 rounded-full bg-warm-alt flex items-center justify-center" data-id="element-248">
                      <BookOpen className="w-5 h-5 text-warm-accent" data-id="element-249" />
                    </div>
                    <p className="text-sm text-warm-dark/70" data-id="element-250">
                      Lectura práctica y accesible
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}